// eslint-disable-next-line no-shadow
enum EmailType {
  PAYMENT,
  CONTACT,
  NOT_REPPLY,
}
export default EmailType;
